import React, { useEffect, useState } from 'react'
import Cards from '../components/Cards/Cards'
import AgentsTable from '../components/Tables/AgentsTable'
import { FiPlusCircle } from "react-icons/fi";
import { Link } from 'react-router-dom';
import { localurl } from '../components/utils';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
const Agents = () => {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [agentData, setAgentData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${localurl}/agents/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setAgents(response.data);
      }
      catch (error) {
        toast.error("Error fetching user data:", error)
      }
    };
    fetchData();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${localurl}/agent/info/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setAgentData(response.data);
      }
      catch (error) {
        toast.error(error)
      }
    };
    fetchData()
  }, [])


  const agentColumns = [
    { Header: "User Name", accessor: "username" },
    { Header: "Email", accessor: "email" },
    { Header: "Status", accessor: "is_active" },
    { Header: "Working Days", accessor: "availability.working_days" },
    { Header: "Working Hours", accessor: "availability" },
  ]

  return (
    <div className='flex flex-col w-full' >
      <h1 className="text-black font-bold text-2xl mb-3">Escalations</h1>
      <p className="font-normal text-base text-gray-600 mb-5">
        Manage conversations that require human intervention
      </p>
      <div className="flex flex-row justify-between gap-5 max-lg:flex-col mt-1">
        <Cards
          category={"Total Conversations"}
          number={agentData?.total_interaction_this_month}
          percent={agentData?.total_interactions_last_month}
          previous={"from last month"}
          percentColor={
            agentData?.total_interactions_last_month >= 0
              ? "text-green-300"
              : "text-red-400"
          }
        />
        <Cards
          category={"Resolution Rate"}
          number={agentData?.resolution_rate}
          previous={"Awaiting agent assignment"}
        />
        <Cards
          category={"Avg. Response Time"}
          number={agentData?.average_response_time_seconds}
          percent={agentData?.percentage_change_interactions}
          previous={"from last month"}
          percentColor={
            agentData?.percentage_change_interactions >= 0
              ? "text-green-300"
              : "text-red-400"
          }
        />
      </div>
      <div className='mt-6 p-3 pb-6 rounded-xl bg-white shadow-md'>
        <div className='py-3 mb-1 flex flex-row justify-between items-center'>
          <div className='flex flex-col gap-3'>
            <p className='text-black text-xl font-semibold'>Agents</p>
            <p className='text-[#71717A] text-sm font-normal '>Manage your AI and human support agents</p>
          </div>
          <div>
            <Link to="/add-agent" className='text-md bg-[#42973F] text-white flex flex-row gap-2 p-2 px-4 rounded-md items-center cursor-pointer'><FiPlusCircle />Add Agent</Link>
          </div>
        </div>
        <AgentsTable
          columns={agentColumns}
          data={agents}
          onEdit={(agent) => navigate(`/edit-agent/${agent.id}`)}
          onDelete={(agent) => toast.success('Delete agent:', agent)}
        />
      </div>
    </div>
  )
}

export default Agents